module.exports = "<app-route-edit-segments route=$ctrl.route on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)></app-route-edit-segments> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/edit/segments/template.html
// module id = 484
// module chunks = 0